import React, { useMemo, useState } from 'react';
import DataTable from '../DataTable';
import StatCard from '../StatCard';
import Badge from '../common/Badge';
import { t } from '../../i18n';

const historySeed = [
  { id: 'wh-1', proveedor: 'ConstruSolar SpA', contrato: 'EPC Leyda', avanceFisico: 72, avanceFinanciero: 64, reclamos: 1, score: 82 },
  { id: 'wh-2', proveedor: 'InfraPower Latam', contrato: 'BOP Hurtado', avanceFisico: 48, avanceFinanciero: 45, reclamos: 1, score: 71 },
  { id: 'wh-3', proveedor: 'PowerStorage Consortium', contrato: 'BESS Leyda', avanceFisico: 85, avanceFinanciero: 82, reclamos: 0, score: 90 }
];

const scoreTone = (score) => {
  if (score >= 85) return 'success';
  if (score >= 75) return 'warning';
  return 'danger';
};

const SuppliersWorkHistory = () => {
  const [supplierFilter, setSupplierFilter] = useState('Todos');

  const filteredRows = useMemo(() => {
    if (supplierFilter === 'Todos') return historySeed;
    return historySeed.filter((row) => row.proveedor === supplierFilter);
  }, [supplierFilter]);

  const avgScore = useMemo(() => {
    if (filteredRows.length === 0) return 0;
    return Math.round(filteredRows.reduce((sum, row) => sum + row.score, 0) / filteredRows.length);
  }, [filteredRows]);

  const columns = [
    { key: 'proveedor', label: t('Proveedor'), sortable: true },
    { key: 'contrato', label: t('Contrato'), sortable: true },
    { key: 'avanceFisico', label: t('Avance fisico'), sortable: true, align: 'right', render: (value) => `${value}%` },
    { key: 'avanceFinanciero', label: t('Avance financiero'), sortable: true, align: 'right', render: (value) => `${value}%` },
    { key: 'reclamos', label: t('Reclamos'), sortable: true, align: 'right' },
    {
      key: 'score',
      label: t('Score'),
      sortable: true,
      render: (value) => <Badge tone={scoreTone(value)}>{t(value)}</Badge>
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold text-neutral-900">{t('Historial de Trabajos')}</h1>
          <p className="text-sm text-neutral-500">{t('Avances, analisis de desempeno y seguimiento historico por contrato.')}</p>
        </div>
        <select
          value={supplierFilter}
          onChange={(event) => setSupplierFilter(event.target.value)}
          className="h-8 px-3 rounded border border-neutral-300 text-sm focus:outline-none focus:ring-1 focus:ring-brand-400 focus:border-brand-400"
        >
          <option>{t('Todos')}</option>
          <option>{t('ConstruSolar SpA')}</option>
          <option>{t('InfraPower Latam')}</option>
          <option>{t('PowerStorage Consortium')}</option>
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatCard title={t('Contratos visibles')} value={filteredRows.length} />
        <StatCard title={t('Score promedio')} value={avgScore} />
        <StatCard title={t('Reclamos totales')} value={filteredRows.reduce((s, r) => s + r.reclamos, 0)} />
      </div>

      <DataTable
        data={filteredRows}
        columns={columns}
        searchPlaceholder={t('Buscar proveedor o contrato...')}
      />
    </div>
  );
};

export default SuppliersWorkHistory;
